import { useEffect, useState } from 'react'
import { supabase } from '../../services/supabase'
import { useSimpleHqAccess } from './useSimpleHqAccess'
import type { SimpleHqRole } from './constants'

type RosterRow = { user_id: string; email: string; role: SimpleHqRole }

export function DelegatesView() {
  const { companyId } = useSimpleHqAccess()
  const [roster, setRoster] = useState<RosterRow[]>([])
  const [msg, setMsg] = useState<string | null>(null)

  const load = async () => {
    const { data } = await supabase.rpc('simple_hq_roster')
    setRoster((data as RosterRow[]) || [])
  }

  useEffect(() => {
    void load()
  }, [companyId])

  const setRole = async (userId: string, role: SimpleHqRole) => {
    const { error } = await supabase
      .from('simple_hq_roles')
      .update({ role, updated_at: new Date().toISOString() })
      .eq('company_id', companyId)
      .eq('user_id', userId)
    if (error) alert(error.message)
    else {
      setMsg(`Updated role to ${role}`)
      await load()
    }
  }

  return (
    <div>
      <p className="hq-eyebrow">Settings</p>
      <h1 className="hq-title">Delegates</h1>
      <p className="hq-sub">
        Delegates can approve leave and assign tasks. Only HQ admin can change entitlements.
      </p>
      {msg && <div className="hq-ok-box">{msg}</div>}
      <div className="hq-panel">
        <div className="hq-table-wrap">
          <table className="hq-table">
            <thead>
              <tr>
                <th>Email</th>
                <th>Role</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {roster.map((r) => (
                <tr key={r.user_id}>
                  <td>{r.email}</td>
                  <td>
                    <span className="hq-badge">{r.role}</span>
                  </td>
                  <td className="flex gap-2">
                    {r.role !== 'admin' && (
                      <>
                        <button type="button" className="hq-btn" onClick={() => void setRole(r.user_id, 'delegate')}>
                          Make delegate
                        </button>
                        <button type="button" className="hq-btn" onClick={() => void setRole(r.user_id, 'member')}>
                          Make member
                        </button>
                      </>
                    )}
                    {r.role === 'admin' && <span className="text-xs text-[var(--hq-muted)]">HQ admin</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
